var exports = {
  "kL": "x61f99309--f2d62d--container",
  "x6": "x61f99309--f2d62d--button",
  "Sl": "x61f99309--f2d62d--image",
  "R_": "x61f99309--f2d62d--heading",
};

module.exports = exports;
